:host {
  display: block;
}

.vs-marquee-media-wrapper {
  position: relative;
  height: auto;
  -webkit-user-select: none;  /* Chrome, Safari, Opera */
  -moz-user-select: none;     /* Firefox */
  -ms-user-select: none;      /* IE 10+ */
  user-select: none;  
  transition: height 1s ease-in-out;
  -webkit-transition: height 1s ease-in-out;
  -moz-transition: height 1s ease-in-out;
  -o-transition: height 1s ease-in-out;
    
}

